<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import type { TwoColImageComponent } from "$lib/js/strapi/types";

  export let component: TwoColImageComponent

  let image = component?.image;
  let uClass = ''
  let uPaddings = ''
  let uColor = 'transparent'

  if(component.image_left === true) {
    uClass = 'left'
  }

  if( component.bg_color ) {
    uColor = component.bg_color;
    uPaddings = 'bg'
  }
</script>


<div class="two-col-image {uPaddings}">
  <div style="background-color: {uColor}" class="two-col-image__inner">
    <div class="two-col-image__text {uClass}">
      <h2>{component.title}</h2>
      <p>{@html component.description}</p>
    </div>

    <div class="two-col-image__img">
      <Lazy height={200}>
        <img src="{PUBLIC_STRAPI_MEDIA}{image.url}" alt="" height="{image.height}" width="{image.width}">
      </Lazy>
    </div>
  </div>
</div>


<style lang="scss">
  .two-col-image {
    margin: 25px 0;

    @media (min-width: 769px) {
      margin: 50px 0;
    }

    &.bg {
      .two-col-image {
        &__text {
          padding: 40px 60px 10px;

          @media (min-width: 769px) {
            padding: 40px 60px;
          }
        }

        &__text,
        &__img {
          @media (min-width: 769px) {
            width: calc(50% - 60px);
          }
        }
      }
    }

    &__inner {
      @media (min-width: 769px) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
      }
    }

    &__text {
      margin-bottom: 40px;

      @media (min-width: 769px) {
        margin-bottom: 0;
        padding-right: 60px;
        width: calc(52% - 60px);
      }

      &.left {
        order: 2;
        padding-right: 0;

        @media (min-width: 769px) {
          padding-left: 60px;
        }
      }
    }

    &__img {
      display: flex;

      @media (min-width: 769px) {
        width: 48%;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
</style>
